module.exports = __webpack_public_path__ + "media/images/light/logo/logo-55049668e577c5aa1019fbf2dd8e8e9b.png";